import { IsInt, IsOptional, Min } from 'class-validator';
import { Type } from 'class-transformer';

export class CategoriesListDto {
  @Type(() => Number)
  @IsInt()
  @IsOptional()
  // eslint-disable-next-line no-magic-numbers
  limit = 20;

  @Min(0)
  @IsInt()
  @Type(() => Number)
  @IsOptional()
  offset = 0;
}
